(function(){
  function domReady(fn){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn,{once:true});}else{fn();}}
  domReady(function(){
    var modal=document.querySelector('[data-mv-consent]');
    if(!modal||!window.Shopify||typeof window.Shopify.loadFeatures!=='function')return;

    var api=null;
    var analytics=modal.querySelector('[data-mv-consent-analytics]');
    var preferences=modal.querySelector('[data-mv-consent-preferences]');
    var marketing=modal.querySelector('[data-mv-consent-marketing]');
    var details=modal.querySelector('[data-mv-consent-details]');
    var lastFocus=null;
    var backupCookie='mv_cookie_consent_v2';
    var backupStorageKey='mv_cookie_consent_v2';
    var backupMaxAgeSeconds=180*24*60*60;
    var backupMaxAgeMs=backupMaxAgeSeconds*1000;

    function consentState(){
      try{return api&&api.currentVisitorConsent?api.currentVisitorConsent():{};}catch(e){return {};}
    }

    function normalizeConsent(c){
      if(!c)return null;
      var out={};
      ['analytics','preferences','marketing'].forEach(function(key){
        if(c[key]==='yes'||c[key]===true)out[key]=true;
        else if(c[key]==='no'||c[key]===false)out[key]=false;
      });
      return Object.keys(out).length===3?out:null;
    }

    function parseBackup(raw){
      try{
        if(!raw)return null;
        var parsed=JSON.parse(raw);
        if(!parsed||!parsed.savedAt||Date.now()-parsed.savedAt>backupMaxAgeMs)return null;
        if(typeof parsed.analytics!=='boolean'||typeof parsed.preferences!=='boolean'||typeof parsed.marketing!=='boolean')return null;
        return {analytics:parsed.analytics,preferences:parsed.preferences,marketing:parsed.marketing};
      }catch(e){return null;}
    }

    function deleteBackup(){
      try{document.cookie=backupCookie+'=; Max-Age=0; Path=/; SameSite=Lax'+(location.protocol==='https:'?'; Secure':'');}catch(e){}
      try{window.localStorage.removeItem(backupStorageKey);}catch(e){}
    }

    function readBackup(){
      try{
        var prefix=backupCookie+'=';
        var parts=document.cookie?document.cookie.split(';'):[];
        for(var i=0;i<parts.length;i++){
          var part=parts[i].trim();
          if(part.indexOf(prefix)===0){
            var fromCookie=parseBackup(decodeURIComponent(part.slice(prefix.length)));
            if(fromCookie)return fromCookie;
          }
        }
      }catch(e){}
      try{
        var fromStorage=parseBackup(window.localStorage.getItem(backupStorageKey));
        if(fromStorage)return fromStorage;
      }catch(e){}
      deleteBackup();
      return null;
    }

    function writeBackup(values){
      var record={analytics:!!values.analytics,preferences:!!values.preferences,marketing:!!values.marketing,savedAt:Date.now()};
      try{
        document.cookie=backupCookie+'='+encodeURIComponent(JSON.stringify(record))+'; Max-Age='+backupMaxAgeSeconds+'; Path=/; SameSite=Lax'+(location.protocol==='https:'?'; Secure':'');
      }catch(e){}
      try{window.localStorage.setItem(backupStorageKey,JSON.stringify(record));}catch(e){}
    }

    function currentChoice(){
      return normalizeConsent(consentState())||readBackup()||{analytics:false,preferences:false,marketing:false};
    }

    function fillControls(){
      var c=currentChoice();
      if(analytics)analytics.checked=!!c.analytics;
      if(preferences)preferences.checked=!!c.preferences;
      if(marketing)marketing.checked=!!c.marketing;
    }

    function open(customize){
      lastFocus=document.activeElement;
      fillControls();
      modal.hidden=false;
      document.documentElement.classList.add('mv-consent-open');
      if(details)details.hidden=!customize;
      var target=customize&&analytics?analytics:modal.querySelector('button:not([disabled])');
      if(target)setTimeout(function(){target.focus();},0);
    }

    function close(){
      modal.hidden=true;
      document.documentElement.classList.remove('mv-consent-open');
      if(lastFocus&&typeof lastFocus.focus==='function')lastFocus.focus();
    }

    function apply(values){
      if(!api||!api.setTrackingConsent)return;
      writeBackup(values);
      api.setTrackingConsent(values,function(){
        writeBackup(values);
        close();
      });
    }

    modal.querySelector('[data-mv-consent-accept]').addEventListener('click',function(){apply({analytics:true,preferences:true,marketing:true});});
    modal.querySelector('[data-mv-consent-reject]').addEventListener('click',function(){apply({analytics:false,preferences:false,marketing:false});});
    modal.querySelector('[data-mv-consent-customize]').addEventListener('click',function(){fillControls();details.hidden=false;if(analytics)analytics.focus();});
    modal.querySelector('[data-mv-consent-save]').addEventListener('click',function(){apply({analytics:!!analytics.checked,preferences:!!preferences.checked,marketing:!!marketing.checked});});
    document.querySelectorAll('[data-mv-cookie-preferences]').forEach(function(btn){btn.addEventListener('click',function(){open(true);});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)close();});

    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){
      if(error||!window.Shopify.customerPrivacy)return;
      api=window.Shopify.customerPrivacy;

      var current=normalizeConsent(consentState());
      if(current){
        writeBackup(current);
        return;
      }

      var backup=readBackup();
      if(backup){
        try{api.setTrackingConsent(backup,function(){writeBackup(backup);});}catch(e){}
        return;
      }

      var region='';
      var configured=false;
      try{region=api.getRegion?String(api.getRegion()||''):'';}catch(e){}
      try{configured=api.shouldShowBanner?!!api.shouldShowBanner():false;}catch(e){}
      var isSweden=region.slice(0,2).toUpperCase()==='SE';
      if(isSweden||configured)open(false);
    });
  });
})();
